// @ts-nocheck
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import updateWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/UpdateWishList";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer from "@insite/content-library/Components/CardContainer";
import CardList from "@insite/content-library/Components/CardList";
// import CardListHeading from "@insite/content-library/Components/CardListHeading"; // Starter Custom Code
// import WishListCard, { WishListCardStyles } from "@insite/content-library/Components/WishListCard";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import deleteWishList from "@insite/client-framework/Store/Pages/MyLists/Handlers/DeleteWishList";
import deleteWishListShare from "@insite/client-framework/Store/Pages/MyLists/Handlers/DeleteWishListShare";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import { wishListTableProps } from "@store/Themes/common/props/wishList";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import withHookProps, { HookPropsInjector } from "@toolkit/Framework/Common/Utilities/withHookProps";
/* Starter Custom Code */

/* Foundation - Start */
// import WishListCard, { WishListCardStyles } from "@store/Overrides/Components/WishListCard";
import { DataTablePresentationProps } from "@insite/mobius/DataTable";
/* Foundation - End */

// bunzl custom dode
import WishListCard, { WishListCardStyles } from "@store/Overrides/Components/WishListCard";
/* Starter Custom Code - Start */
interface HookProps {
    persistentDataView: ReturnType<typeof getWishListsDataView>;
    trackDeleteWishList: ReturnType<typeof ga.use.trackDeleteWishList>;
}

const hookPropsInjector: HookPropsInjector<Props, HookProps> = ({ recentWishListsDataView }) => ({
    persistentDataView: usePersistentDataView(recentWishListsDataView),
    trackDeleteWishList: ga.use.trackDeleteWishList(),
});

interface State {
    wishListToAction?: WishListModel;
    deleteListModalIsOpen: boolean;
    leaveListModalIsOpen: boolean;
}
/* Starter Custom Code - End */
const enum fields {
    numberOfRecords = "numberOfRecords",
    // Foundation
    showDescription = "showDescription",
    oneLineView = "oneLineView",
    /* Store Custom Code - Start */
    hideHideListButton = "hideHideListButton",
    hideUnhideListButton = "hideUnhideListButton",
    /* Store Custom Code - End */
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfRecords]: number;
        // Foundation
        [fields.showDescription]: boolean;
        // Store Custom Code
        [fields.oneLineView]: boolean;
        /* Store Custom Code - Start */
        [fields.hideHideListButton]: boolean;
        [fields.hideUnhideListButton]: boolean;
        /* Store Custom Code - End */
    };
    // Starter Custom Code
    persistentDataView: ReturnType<typeof getWishListsDataView>;
    trackDeleteWishList: ReturnType<typeof ga.use.trackDeleteWishList>;
}

/* Foundation - Start */
interface State {
    wishListToAction?: WishListModel;
    deleteListModalIsOpen: boolean;
}
/* Foundation - End */

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    return {
        recentWishListsDataView: getWishListsDataView(state, recentWishListsParameter),
        myListsPageNavLink: getPageLinkByPageType(state, "MyListsPage"),
        canViewWishLists: (session.isAuthenticated || session.rememberMe) && !session.isGuest,
    };
};

let recentWishListsParameter = {
    page: 1,

    sort: "ModifiedOn DESC",
    additionalExpands: ["wishListLineCount"],
} as GetWishListsApiParameter;

const mapDispatchToProps = {
    loadWishLists,
    addWishListToCart,
    updateWishList,
    // Starter Custom Code
    deleteWishListShare,
    deleteWishList, // Foundation
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RecentWishListsStyles {
    wishListCardGridItem?: GridItemProps;
    noWishListsText?: TypographyProps;
    wishListCard?: WishListCardStyles;
    // Starter Custom Code
    wrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    dataTable?: DataTableProps;
    listNameHeader?: DataTableHeaderProps;
    dateHeader?: DataTableHeaderProps;
    itemsHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    actionsHeader?: DataTableHeaderProps;
    // Foundation
    tableWrapper?: DataTablePresentationProps;
}

export const recentWishListsStyles: RecentWishListsStyles = {
    wishListCardGridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
    wishListCard: {
        actionAddToCartButton: {
            typographyProps: {
                size: 14,
            },
        },
    },
    noWishListsText: typographyGetNoResultsProps(),
    loadingOverlay: { minHeight: 80 },
    tableWrapper: wishListTableProps.wrapper,
    dataTable: wishListTableProps.dataTable,
    listNameHeader: wishListTableProps.listNameHeader,
    dateHeader: wishListTableProps.dateHeader,
    itemsHeader: wishListTableProps.itemsHeader,
    statusHeader: wishListTableProps.statusHeader,
    actionsHeader: wishListTableProps.actionsHeader,
};

const styles = recentWishListsStyles;

class RecentWishLists extends React.Component<Props, State /* Starter Custom Code */> {
    /* Starter Custom Code - Start */
    static contextType = ToasterContext;
    context!: React.ContextType<typeof ToasterContext>;

    constructor(props: Props) {
        super(props);
        this.state = {
            deleteListModalIsOpen: false,
            leaveListModalIsOpen: false,
        };
    }
    /* Starter Custom Code - End */

    componentDidMount() {
        recentWishListsParameter.pageSize = this.props.fields.numberOfRecords;
        if (
            this.props.canViewWishLists &&
            !this.props.recentWishListsDataView.value &&
            !this.props.recentWishListsDataView.isLoading
        ) {
            this.props.loadWishLists(recentWishListsParameter);
        }
    }

    componentDidUpdate() {
        if (
            this.props.canViewWishLists &&
            !this.props.recentWishListsDataView.value &&
            !this.props.recentWishListsDataView.isLoading
        ) {
            this.props.loadWishLists(recentWishListsParameter);
        }
    }

    /* Foundation - Start */
    deleteButtonClickHandler = (wishList: WishListModel) => {
        this.setState({
            wishListToAction: wishList,
            deleteListModalIsOpen: true,
        });
    };

    deleteCancelHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
    };

    deleteSubmitHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
        if (this.state.wishListToAction) {
            this.props.deleteWishList({
                wishListId: this.state.wishListToAction.id,
                onSuccess: this.onDeleteSuccess,
                onComplete(resultProps) {
                    if (!resultProps.error) {
                        this.onSuccess?.();
                    }
                },
            });
        }
    };

    onDeleteSuccess = () => {
        this.context.addToast({ body: translate("List Deleted"), messageType: "success" });
        this.props.loadWishLists(recentWishListsParameter);
        this.props.trackDeleteWishList({}, { wishList: this.state.wishListToAction }); // Starter Custom Code
    };
    /* Foundation - End */
    leaveButtonClickHandler = (wishList: WishListModel) => {
        this.setState({
            wishListToAction: wishList,
            leaveListModalIsOpen: true,
        });
    };

    leaveCancelHandler = () => {
        this.setState({ leaveListModalIsOpen: false });
    };

    leaveSubmitHandler = () => {
        this.setState({ leaveListModalIsOpen: false });
        if (this.state.wishListToAction) {
            this.props.deleteWishListShare({
                wishList: this.state.wishListToAction,
                onSuccess: this.onLeaveSuccess,
                onComplete() {
                    this.onSuccess?.();
                },
            });
        }
    };

    onLeaveSuccess = () => {
        this.context.addToast({ body: translate("You left the list"), messageType: "success" });
    };
    /* Starter Custom Code */

    toggleFavoriteClickHandler = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isFavorite: !wishList.isFavorite,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    this.onSuccess?.();
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    toggleHideClickHandler = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isHidden: !wishList.isHidden,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    this.onSuccess?.();
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };
    render() {
        if (!this.props.canViewWishLists) {
            return null;
        }

        const {
            persistentDataView: { value: recentWishLists }, // Starter Custom Code
            myListsPageNavLink,
        } = this.props;
        const myListsPageUrl = myListsPageNavLink ? myListsPageNavLink.url : undefined;

        /* Starter Custom Code */
        const hasNoResults = !recentWishLists || recentWishLists.length === 0;

        return (
            <StyledWrapper {...styles.wrapper}>
                <CardListHeading
                    heading={translate("My Lists")}
                    viewAllUrl={myListsPageUrl}
                    hasNoResults={hasNoResults}
                />
                <DataViewLoadingOverlay {...styles.loadingOverlay} dataView={this.props.persistentDataView}>
                    {hasNoResults ? (
                        <Typography {...styles.noWishListsText}>{siteMessage("WishLists_NoWishlistsFound")}</Typography>
                    ) : (
                        <StyledWrapper {...styles.tableWrapper}>
                            <DataTable {...styles.dataTable}>
                                <DataTableHead>
                                    <DataTableHeader {...styles.listNameHeader}>{translate("Name")}</DataTableHeader>
                                    {this.props.fields.showDescription && (
                                        <DataTableHeader {...styles.listNameHeader}>
                                            {translate("Description")}
                                        </DataTableHeader>
                                    )}

                                    <DataTableHeader {...styles.itemsHeader}>{translate("# Items")}</DataTableHeader>
                                    <DataTableHeader {...styles.statusHeader}>{translate("Status")}</DataTableHeader>
                                    <DataTableHeader {...styles.actionsHeader}></DataTableHeader>
                                </DataTableHead>
                                <DataTableBody>
                                    {recentWishLists?.map(wishList => (
                                        <WishListCard
                                            key={wishList.id}
                                            toggleHide={() => this.toggleHideClickHandler(wishList)}
                                            toggleFavorite={() => this.toggleFavoriteClickHandler(wishList)}
                                            wishList={wishList}
                                            oneLineView={this.props.fields.oneLineView}
                                            addWishListToCart={this.props.addWishListToCart}
                                            deleteWishList={() => this.deleteButtonClickHandler(wishList)}
                                            leaveWishList={() => this.leaveButtonClickHandler(wishList)}
                                            extendedStyles={styles.wishListCard}
                                            // Foundation
                                            showDescription={this.props.fields.showDescription}
                                            /* Store Custom Code - Start */
                                            showHideButton={!this.props.fields.hideHideListButton}
                                            showUnhideButton={!this.props.fields.hideUnhideListButton}
                                            /* Store Custom Code - End */
                                        />
                                    ))}
                                </DataTableBody>
                            </DataTable>
                        </StyledWrapper>
                    )}
                    <TwoButtonModal
                        modalIsOpen={this.state.deleteListModalIsOpen}
                        headlineText={translate("Delete List")}
                        messageText={`${translate("Are you sure you want to delete")} ${
                            this.state.wishListToAction ? this.state.wishListToAction.name : ""
                        }?`}
                        cancelButtonText={translate("Cancel")}
                        submitButtonText={translate("Delete")}
                        onCancel={this.deleteCancelHandler}
                        onSubmit={this.deleteSubmitHandler}
                        submitTestSelector="myListsListSubmitDelete"
                    ></TwoButtonModal>
                    <TwoButtonModal
                        modalIsOpen={this.state.leaveListModalIsOpen}
                        headlineText={translate("Leave List")}
                        messageText={`${translate("Are you sure you want to leave")} ${
                            this.state.wishListToAction ? this.state.wishListToAction.name : ""
                        }?`}
                        cancelButtonText={translate("Cancel")}
                        submitButtonText={translate("Leave")}
                        onCancel={this.leaveCancelHandler}
                        onSubmit={this.leaveSubmitHandler}
                        submitTestSelector="myListsListSubmitLeave"
                    ></TwoButtonModal>
                </DataViewLoadingOverlay>
            </StyledWrapper>
        );
        /* Starter Custom Code */
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHookProps(RecentWishLists, hookPropsInjector)), // Starter Custom Code
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.numberOfRecords,
                displayName: "Number of Lists Displayed",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 3,
                fieldType: "General",
                sortOrder: 1,
            },
            // Foundation
            {
                name: fields.showDescription,
                displayName: "Show Description",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.oneLineView,
                displayName: "One Line View",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
            },
            /* Store Custom Code - Start */
            {
                name: fields.hideHideListButton,
                displayName: "Hide 'Hide List' Button",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.hideUnhideListButton,
                displayName: "Hide 'Unhide List' Button",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 5,
            },
            /* Store Custom Code - End */
        ],
    },
};

export default widgetModule;
